import { useNavigate } from "react-router-dom";
import { Button } from "../button";
import { Column } from "../column";
import { Container } from "../container";
import { DFlexResponsive } from "../d-flex-responsive";
import { Row } from "../row";

export function RouteError({ message = "Error", navigateTo = "" }) {
  const navigate = useNavigate();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h3>{message}</h3>

            {!!navigateTo.length && (
              <Button
                onClick={() => {
                  navigate(navigateTo);
                }}
                title="Regresar"
              />
            )}
          </DFlexResponsive>
        </Column>
      </Row>
    </Container>
  );
}
